import React from 'react';
import PropTypes from 'prop-types';

import 'components/InterviewerList.scss';
import InterviewListItem from './InterviewerListItem';

export default function InterviewerList(props) {
  const interviewers =
    Array.isArray(props.interviewers) &&
    props.interviewers.map(interviewer => {
      return (
        <InterviewListItem
          key={interviewer.id}
          name={interviewer.name}
          avatar={interviewer.avatar}
          selected={interviewer.id === props.value}
          setInterviewer={event => props.onChange(interviewer.id)}
        />
      );
    });

  return (
    <section className="interviewers">
      <h4 className="interviewers__header text--light">Interviewer</h4>
      <ul className="interviewers__list">{interviewers}</ul>
    </section>
  );
}

InterviewerList.propTypes = {
  interviewers: PropTypes.array.isRequired
};
